export const InteractiveCourseware = {
    "有疑问":"有疑问",
    "有提问":"有提问",
    "学习开始时间":"学习开始时间",
    "学习已开始":"学习已开始",
    "是否结束发布":"Whether to end publishing",
    "结束发布后学生将无法进入本课件学习":"After the release, students will not be able to enter this courseware for learning",
    "学习页面":"Pages Learned",
    "疑问数":"Number of problems",
    "评论数":"Number of comments",
    "学习时间":"Time of learning",
    "更换":"replace",
    "课件标题":"Courseware Title",
    "活动类型标签":"Type label",
    "课件内容":"Courseware content",
    "增加内容分段":"Add",
    "允许作答试题":"Allow to answer questions",
    "允许下载":"Allow download",
    "不允许下载":"Not allow download",
    "总分":"Total score",
    "截止时间":"Deadline",
    "请选择章节目录":"Please select the chapter directory",
    "系统检测到您的当前设备暂不支持全屏模式":"The system has detected that your device does not support full screen mode",
    "没有下一页了":"No next page",
    "当前是第一页":"Already the first page",
    "页的讨论":"'s comments",
    "是否删除该评论":"Whether to delete the comment?",
    "批阅互动答题":"Review interactive answers",
    "试题分析":"Item analysis",
    "互动批阅":"Interactive question review",
    "您共学习了":"You have learned",
    "页这是最后一页是否标记为“已完成学习":"pages, this is the last page, whether to mark it as completed?",
    "此课件为空点击返回":"This courseware is empty, click Back",
    "老师已收到疑问":"The teacher has received questions",
    "有疑问学生":"Students with questions",
    "课件学习":"Courseware learning",
    "学习统计":"Learning statistics",
    
}